"use client";

import React, { useState } from "react";
import { Funnel, Crosshair } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
const categories = [{
  id: "all",
  label: "ALLE"
}, {
  id: "abort",
  label: "ABORT"
}, {
  id: "disciplin",
  label: "DISCIPLIN"
}, {
  id: "kristendom",
  label: "KRISTENDOM"
}, {
  id: "samfund",
  label: "SAMFUND"
}, {
  id: "politik",
  label: "POLITIK"
}];
export default function EmneFokus() {
  const [activeFilter, setActiveFilter] = useState("all");
  return <section id="emne-fokus" className="dark bg-background text-foreground py-8 border-y-2 border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="flex items-center gap-3 text-muted-foreground font-mono text-sm tracking-widest uppercase shrink-0">
            <Crosshair className="w-5 h-5 text-primary" />
            <span className="hidden md:inline-block">
              FILTER_PROTOKOL: <span className="text-foreground font-bold">{activeFilter.toUpperCase()}</span>
            </span>
            <span className="md:hidden">FILTRE</span>
          </div>

          {}
          <div className="w-full md:w-auto overflow-x-auto pb-2 md:pb-0 scrollbar-hide">
            <ToggleGroup type="single" value={activeFilter} onValueChange={value => {
            if (value) setActiveFilter(value);
          }} className="flex-nowrap gap-2 md:gap-0">
              {categories.map((category, i) => <ToggleGroupItem key={category.id} value={category.id} data-index={i} className="
                    rounded-none border-2 border-border bg-card text-muted-foreground
                    font-mono text-xs md:text-sm font-bold tracking-wider uppercase
                    transition-all duration-200
                    hover:bg-accent hover:text-accent-foreground hover:border-accent-foreground
                    data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:border-primary
                    px-4 py-2 h-10 md:h-12 min-w-[100px] md:min-w-[auto]
                    md:first:border-r-0 md:last:border-l-0 md:[&:not(:first-child):not(:last-child)]:border-x-0
                  ">
                  {category.label}
                </ToggleGroupItem>)}
            </ToggleGroup>
          </div>

          {}
          <div className="hidden md:flex items-center gap-2 text-xs font-mono text-muted-foreground opacity-50">
            <Funnel className="w-4 h-4" />
            <span>INDEX_V.1.0</span>
          </div>
        </div>
      </div>
    </section>;
}